import { render, staticRenderFns } from "./SingleLayerAttributesInfos.vue?vue&type=template&id=1aee5bb3&scoped=true"
import script from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerAttributesInfos.vue?vue&type=style&index=0&id=1aee5bb3&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1aee5bb3",
  null
  ,true
)

export default component.exports